// AI Generated Test
import { Component, forwardRef, Input, OnInit, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'form-field-select',
    templateUrl: './form-field-select.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormFieldSelectComponent),
            multi: true,
        },
    ],
})
export class FormFieldSelectComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    @Input() ngRequired: boolean = false;
    @Input() label: string = '';
    @Input() hideLabel = false;
    @Input() helpTxt: string = '';
    @Input() defaultOption: string = 'Choose an option';
    @Input() returnValue: string = '';
    @Input() nameAttr: string = 'name';
    @Input() multiple: boolean = false;
    @Input() group: string = 'group';
    @Input() removeButton: boolean = false;
    @Input() disabled: boolean = false;
    @Input() disableSearch: boolean = false;
    @Input() options: any[] = [];
    @Input() viewTemplate: string = '';
    @Input() dropdownTemplate: string = '';
    @Input() groupTemplate: string = '';

    @Output() ngChange = new EventEmitter<{ newValue: any, oldValue: any }>();

    @ViewChild('formGroupRef', { static: true }) formGroupRef!: ElementRef;

    private _value: any = '';
    private _onChange = (value: any) => {};
    private _onTouched = () => {};
    public _isTouched = false;
    public containerWidth: string = 'col-sm-48';

    constructor (private elementRef: ElementRef) {}

    ngOnInit (): void {
        this.ngRequired = this.ngRequired || false;
        this.defaultOption = this.defaultOption || 'Choose an option';
        this.returnValue = this.returnValue || '';
        this.nameAttr = this.nameAttr || 'name';
        this.containerWidth = this.label && !this.hideLabel ? 'col-sm-40' : 'col-sm-48';
        this.multiple = this.multiple || false;
        this.group = this.group || 'group';
        this.removeButton = this.removeButton || false;
        this.disabled = this.disabled || false;
        this.disableSearch = this.disableSearch || false;

    }

    ngAfterViewInit (): void {
        // Initialize validation state after view is ready
        this.updateValidationClasses();
    }

    get value (): any {
        return this._value;
    }

    set value (val: any) {
        if (val !== this._value) {
            const oldValue = this._value;
            this._value = val;
            this._onChange(val);
            this._onTouched();
            this.emitChange(val, oldValue);
        }
    }

    writeValue (value: any): void {
        if (value !== undefined && value !== null) {
            this._value = value;
        }
    }

    registerOnChange (fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched (fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState (isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onSelectorChange (newValue: any): void {
        this.value = newValue;
        this.updateValidationClasses();
    }

    onSelectorBlur (): void {
        this._isTouched = true;
        this._onTouched();
        this.updateValidationClasses();
    }

    isFieldValid (): boolean {
        if (this.ngRequired && (!this._value || this._value === '')) {
            return false;
        }

        return true;
    }

    public updateValidationClasses (): void {
        if (!this.formGroupRef) {
            return;
        }

        const formGroupElement = this.formGroupRef.nativeElement;
        const isValid = this.isFieldValid();

        if (!isValid && this._isTouched) {
            this.setHasError(formGroupElement);
        } else {
            this.removeHasError(formGroupElement);
        }
    }

    private emitChange (newValue: any, oldValue: any): void {
        setTimeout(() => {
            this.ngChange.emit({ newValue: newValue, oldValue: oldValue });
        });
    }

    private setHasError (formGroupElement: HTMLElement): void {
        if (!formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.add('has-error');
        }
    }

    private removeHasError (formGroupElement: HTMLElement): void {
        if (formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.remove('has-error');
        }
    }
}
